import debouncePromise from 'debounce-promise';

export { debouncePromise };
